module.exports = __webpack_public_path__ + "img/bosspack_dg.2b813a0f.png";